/* Landing luces — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'luces'). */


const fmt=n=>'$'+n.toLocaleString('es-CO');
document.querySelectorAll('#thumbs button').forEach(b=>b.addEventListener('click',()=>{
  document.getElementById('mainImg').src=b.dataset.src;
  document.querySelectorAll('#thumbs button').forEach(x=>x.classList.toggle('on',x===b));
}));
document.querySelectorAll('.combo').forEach(c=>c.addEventListener('click',()=>{
  document.querySelectorAll('.combo').forEach(x=>x.classList.toggle('on',x===c));
  c.querySelector('input').checked=true;
  const p=+c.dataset.price,o=+c.dataset.old;
  document.getElementById('nowP').textContent=fmt(p);
  document.getElementById('oldP').textContent=fmt(o);
  document.getElementById('offP').textContent='−'+Math.round((1-p/o)*100)+'%';
  document.getElementById('sName').textContent=c.dataset.name;
  document.getElementById('sPrice').textContent=fmt(p)+' · Pagas al recibir';
}));
const buy=document.getElementById('comprar'),st=document.getElementById('sticky');
new IntersectionObserver(([e])=>st.classList.toggle('show',!e.isIntersecting&&e.boundingClientRect.top<0)).observe(buy);

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN (memoria project-northpower-landing / project-diosa-landing):
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug NorthPower #1019).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function current() {
    var card = document.querySelector('.luces-landing #combos .combo.on')
            || document.querySelector('.luces-landing #combos .combo');
    return {
      id: window.LUCES_VARIANT,
      qty: card ? (parseInt(card.getAttribute('data-bundle-qty'), 10) || 1) : 1
    };
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('#combos .combo')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  window.lucesTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
